export const mgPlatformArrowDownSimpleIcon = {
  data: `<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.840027 0.560059L4.84003 4.56006L8.84003 0.560059" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-down-simple'
}
